<template>
  <div class="add">
    <!--商品信息-->
    <form-info :formData="formData" :isEdit="false" :testData="testData"></form-info>
  </div>
</template>

<script>
import drawForm from "./live-form";

export default {
  created() {
    //模拟异步触发draw-form组件的watch事件
    setTimeout(() => {
      this.formData = {
        course_mode: "1", //课程类型
        times:'',//副标题
        course_name: "", //课程名字
        started_at: "", //开始时间
        course_duration: 60, //时长
        course_cover: "", //课程封面图片
        publicity_cover: "", //课程宣传封面
        teachers: [
          {
            teacher_name: "", //讲师名称列表
            teacher_title: "", //列表讲师标题
            teacher_introduction: "", //讲师简介列表
            teacher_pfrofile_photo:'' //讲师头像列表
          }
        ],
        course_outline: "", //课程提纲
        common_problem: "", //常见问题,
        // 子组件需要的内容
        is_try: true,//是否可以试听5分钟
        course_sell_price: "", //价格
        course_sell_mode: 1, //售卖方式
        state: 1, //上架设置
        published_at: "", //上架时间
        // home_page_banner: true,
        topic_id:'',//单个关联的id
        collect_form:[],//售卖方式的控件信息
        cooperation_form: [ ],//求合作的控件信息
      };
    });
  },
  components: {
    "form-info": drawForm
  },
  data() {
    return {
      testData: {
      },
      formData: {}
    };
  },
  methods: {
  }
};
</script>

<style scoped lang="less">
</style>